module.exports = "https://www.gc-qa.gnp.com.mx/8b7e731adf1880a3e7425369990d4a84.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/circle-vehiculo.svg
// module id = 377
// module chunks = 0